// 고객 대화 액션(rpc, legacy modules/message/actions) — 직원 글쓰기·사진·고치기·지우기.
import { rpc } from "@/api/client";

export const postStaffMessage = (input: unknown) => rpc("message/actions/postStaffMessage", input);

export const postStaffMessagePhoto = (projectId: string, form: FormData) => rpc("message/actions/postStaffMessagePhoto", projectId, form);

export const editStaffMessage = (input: { project_id: string; message_id: string; body: string; seen_edited_at: string | null }) => rpc("message/actions/editStaffMessage", input);

export const deleteStaffMessage = (input: { project_id: string; message_id: string; seen_edited_at: string | null }) => rpc("message/actions/deleteStaffMessage", input);
